import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse, faSearch, faUser, faHeart, faCartShopping, faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { language } from "../../language/Language";
import { useEffect, useState, useRef } from "react";
import { getCartItemsCount, getFavoritesCount } from "../../utils/localStorage";

function BottomNavigation() {
  const navigate    = useNavigate();
  const user        = JSON.parse(localStorage.getItem("user"));
  const [active, setActive]           = useState("home");
  const [cartCount, setCartCount]     = useState(0);
  const [favoritesCount, setFavCount] = useState(0);
  const [showSearch, setShowSearch]   = useState(false);
  const [searchVal, setSearchVal]     = useState("");
  const searchRef = useRef(null);

  const updateCounts = () => {
    setCartCount(getCartItemsCount());
    setFavCount(getFavoritesCount());
  };

  useEffect(() => {
    updateCounts();
    window.addEventListener("cartUpdated",      updateCounts);
    window.addEventListener("favoritesUpdated", updateCounts);
    return () => {
      window.removeEventListener("cartUpdated",      updateCounts);
      window.removeEventListener("favoritesUpdated", updateCounts);
    };
  }, []);

  useEffect(() => {
    if (showSearch) setTimeout(() => searchRef.current?.focus(), 100);
  }, [showSearch]);

  const go = (name, action) => {
    setActive(name);
    setShowSearch(false);
    if (action) action();
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchVal.trim();
    if (!q) return;
    setShowSearch(false);
    setSearchVal("");
    navigate(`/Products?q=${encodeURIComponent(q)}`);
  };

  /* زرار عادي مع badge */
  const NavBtn = ({ name, icon, label, onClick, count }) => (
    <button
      className="outline-none flex flex-col items-center justify-center gap-[2px] flex-1 h-full cursor-pointer transition-all"
      style={{
        color: "var(--bottom-nav-text-color, #ffffff)",
        opacity: active === name ? 1 : 0.72,
        transform: active === name ? "translateY(-2px)" : "none",
      }}
      onClick={onClick}
    >
      <div className="relative">
        <FontAwesomeIcon icon={icon} className="text-[22px]" />
        {count > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[16px] h-4 bg-white text-mainColor text-[10px] font-bold rounded-full flex items-center justify-center px-[3px]">
            {count}
          </span>
        )}
      </div>
      <span className="text-[10px] font-bold">{label}</span>
    </button>
  );

  return (
    <>
      {/* Search Modal */}
      {showSearch && (
        <div
          className="fixed inset-0 z-50 flex items-end md:hidden"
          style={{ background: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowSearch(false)}
        >
          <div
            className="w-full bg-white rounded-t-2xl p-5 pb-8"
            onClick={(e) => e.stopPropagation()}
          >
            <form onSubmit={handleSearch} dir="rtl" className="flex items-center gap-3">
              <button type="button" onClick={() => setShowSearch(false)} className="text-gray-400 text-xl flex-shrink-0">
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <input
                ref={searchRef}
                type="text"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
                placeholder={language === "ar" ? "ابحث عن منتج..." : "Search products..."}
                className="flex-1 border border-gray-200 rounded-xl px-4 py-3 text-base outline-none focus:border-mainColor"
                style={{ direction: "rtl", fontFamily: "Cairo, sans-serif" }}
              />
              <button
                type="submit"
                className="bg-mainColor text-white px-5 py-3 rounded-xl font-bold flex-shrink-0"
                style={{ fontFamily: "Cairo, sans-serif" }}
              >
                {language === "ar" ? "بحث" : "Go"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* الشريط السفلي */}
      <div
        className="flex w-full h-[62px] items-center justify-around md:!hidden fixed bottom-0 left-0 z-40 px-2"
        style={{
          backgroundColor: "var(--bottom-nav-bg-color, var(--header-bg-color, #c0392b))",
          boxShadow: "0 -4px 20px rgba(0,0,0,0.2)",
        }}
      >
        <NavBtn name="home"   icon={faHouse}        label={language === "ar" ? "الرئيسية" : "Home"}
          onClick={() => go("home",   () => navigate("/"))} />
        <NavBtn name="favorite" icon={faHeart}      label={language === "ar" ? "المفضلة" : "Favorites"}
          count={favoritesCount} onClick={() => go("favorite", () => navigate("/Favorite"))} />

        {/* السلة — نفس شكل باقي الأيقونات، وسط وأكبر قليلاً */}
        <button
          className="outline-none flex flex-col items-center justify-center -mt-4 flex-shrink-0 cursor-pointer"
          onClick={() => go("cart", () => navigate("/Cart"))}
        >
          <div
            className="relative w-12 h-12 rounded-full flex items-center justify-center shadow-lg"
            style={{
              backgroundColor: "var(--cart-fab-color, rgba(255,255,255,0.18))",
              border: "2px solid rgba(255,255,255,0.5)",
            }}
          >
            <FontAwesomeIcon
              icon={faCartShopping}
              style={{ color: "var(--bottom-nav-text-color, #ffffff)", fontSize: 22 }}
            />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-white text-mainColor text-[10px] font-bold rounded-full flex items-center justify-center px-[3px]">
                {cartCount}
              </span>
            )}
          </div>
          <span className="text-[10px] font-bold mt-[2px]"
            style={{ color: "var(--bottom-nav-text-color, #ffffff)" }}>
            {language === "ar" ? "السلة" : "Cart"}
          </span>
        </button>

        <NavBtn name="search" icon={faSearch}       label={language === "ar" ? "بحث" : "Search"}
          onClick={() => { setActive("search"); setShowSearch(true); }} />
        <NavBtn name="profile" icon={faUser}
          label={user ? (language === "ar" ? "حسابي" : "Account") : (language === "ar" ? "دخول" : "Login")}
          onClick={() => go("profile", () => user ? navigate("/ProfileUser") : navigate("/Login"))} />
      </div>

      {/* مسافة أسفل الصفحة على الموبايل */}
      <div className="h-[62px] md:hidden" />
    </>
  );
}

export default BottomNavigation;
